import './contact-block.scss';

export default () => {
};
